import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid rgba(16, 24, 40, 0.06);
  box-shadow: rgba(16, 24, 40, 0.06) 0px 1px 2px 0px,
    rgba(16, 24, 40, 0.1) 0px 1px 3px 0px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  ${({ withScale }) => {
    if (withScale) {
      return css`
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: scale(1.02);
          box-shadow: rgba(16, 24, 40, 0.1) 0px 4px 10px,
            rgba(16, 24, 40, 0.15) 0px 6px 16px;
        }
      `
    }
    return css``
  }}
`

/* ---------- HEADER ---------- */
export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 0.7rem;
  justify-content: space-between;
  align-items: center;
  gap: 0.3rem;
`

export const AccountsWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  .__avatar {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    aspect-ratio: 1 / 1;
  }

  &:hover {
    cursor: pointer;
  }
`

export const Avatar = styled.div`
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
`

export const Identity = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StoreName = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`

/* ---------- BODY ---------- */
export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const SlideItem = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  width: 100%;
  aspect-ratio: 1 / 1;
  position: relative;

  &::before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  > *:not(.product-badge) {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const ImageWrapper = styled.div`
  width: 100%;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  &:hover {
    cursor: pointer;
  }
`

export const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`

export const ProductBadge = styled.div`
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  z-index: 5;

  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;

  background: rgba(0, 0, 0, 0.6);
  color: #fff;

  pointer-events: auto;
`

/* ---------- FOOTER ---------- */
export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 0.7rem;
  flex-direction: column;
  gap: 0.5rem;
`

export const FooterItem = styled.div`
  width: 100%;
  color: #000;
  white-space: pre-line;
  word-break: break-word;
`

export const FooterTitle = styled.span`
  font-size: 0.8rem;
  font-weight: bold;
`

const StyledText = styled.p`
  font-size: 0.8rem;
  margin: 0;
  line-height: 1.2;

  /* min height 2 baris */
  min-height: calc(2 * 1.2em);

  /* default: clamp 2 baris */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;

  /* bantu transisi halus */
  max-height: calc(2 * 1.2em);
  transition: max-height 180ms ease;

  &:hover,
  &:focus,
  &:focus-visible {
    /* buka semua baris */
    -webkit-line-clamp: unset;
    display: block;
    max-height: none;
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
  }
`

export const FooterText = ({ children, ...rest }) => {
  return (
    <StyledText tabIndex={0} {...rest}>
      {children}
    </StyledText>
  )
}
